  <template>
  <v-form>
    <v-container>
      <v-row>
        <v-col cols="12" class="d-flex justify-center">
          <v-text-field
            v-model.trim="$v.codigo.$model"
            prepend-icon="mdi-message-text-outline"
            name="codigo"
            autocomplete="off"
            :error-messages="codigoError"
            label="Código de verificação"
            type="text"
          />
        </v-col>
        <v-btn
          color="primary"
          block
          class="mb-4"
          :disabled="disableBtnCodigo"
          @click="enviarSms"
        >
          <v-icon>mdi-clock-time-four-outline</v-icon>
          enviar codigo
          <span v-show="disableBtnCodigo"> ({{ countDown }})</span>
        </v-btn>
        <v-col cols="12" class="d-flex justify-lg-space-between">
          <v-btn large @click.prevent="voltar"> Voltar </v-btn>
          <v-btn
            :disabled="$v.$invalid || disableSubmit ? true : false"
            color="primary"
            large
            type="submit"
            @click.prevent="submit"
          >
            Enviar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators'
const _TIMER = 30
export default {
  inheritAttrs: true,
  name: 'RecuperacaoSenha',
  data: () => ({
    codigo: '',
    disableBtn: false,
    disableBtnCodigo: true,
    countDown: _TIMER,
    fnTimer:''

  }),
  validations: {
    codigo: {
      required,
      minLength: minLength(6)
    }
  },
  props:['initCount'],
  computed: {
    codigoError () {
      const errors = [];
      const codigo = this.$v.codigo;
      if (!codigo.$dirty) {
        return errors;
      }
      !codigo.required && errors.push('Informe o código')
      !codigo.minLength && errors.push('Código inválido')
      return errors;
    },
    disableSubmit: {
      set (value) {
        this.disableBtn = value
      },
      get () {
        return this.disableBtn
      }
    },
  },
  watch: {
    initCount (value) {
      this.initCount = value;
      this.resetCountDownTimer()
    },
  },
  created () {
    this.resetCountDownTimer()
    this.countDownTimer()
  },
  methods: {
    enviarSms () {
      this.$paguefacil.sendSms('send')
        .then(res => {
          if (res.data.status == 0) {
            this.resetCountDownTimer()
          }
        },
          (e) => {
            this.$store.dispatch('setMsgError', e.data.msg)
            this.$store.dispatch('setDisplayMsgErr', true)
          })
    },
    resetCountDownTimer () {
      this.countDown = _TIMER
      this.countDownTimer()
      this.disableBtnCodigo = true
    },
    countDownTimer () {
      if (this.countDown > 0) {
        this.disableBtnCodigo = true
        this.fnTimer = setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        this.disableBtnCodigo = false
      }
    },
    voltar () {
      this.$emit('action', { page: 1 })
      clearTimeout(this.fnTimer)
    },
    submit () {
      this.disableSubmit = true;
      // this.$paguefacil.sendSms('check')
      this.$paguefacil.sendSms(this.codigo)
        .then(res => {
          this.disableSubmit = false
          if (res.data.status==0) {
            this.$store.dispatch('MsgSucces', res.data.msg)
            this.$store.dispatch('displayMsgSuccess', true)
            //
            this.$emit('action', { page: 4 })
            return false
          }
          // se ocorrer algum erro
          this.$store.dispatch('setMsgError', res.data.msg)
          this.$store.dispatch('setDisplayMsgErr',true)
        },
          (e) => {
            this.disableSubmit = false;
            if(e.response.data) {
              this.$store.dispatch('resetToken')
            }
             this.$store.dispatch('displayLoading', false);
              if (e.response.data) {
                this.$store.dispatch('setMsgError', e.response.data.msg)
                this.$store.dispatch('setDisplayMsgErr', true)
              }
          })
    }
  }
}
</script>